module.exports = __webpack_public_path__ + "media/theme/tutorial__reco--4--redeem-1c3e4039.png";